import InactiveSaved3dSlideTags from './InactiveSaved3dSlideTags'

export default InactiveSaved3dSlideTags
